import { inject } from '@angular/core';
import { Router, RedirectCommand, type CanActivateFn } from '@angular/router';

import { APP_ROUTES } from '@ps/core-config';

const POSITIVE_INTEGER_PATTERN = new RegExp(/^\d+$/);

export function numericParamGuard(paramName: string): CanActivateFn {
  return (route) => {
    const router = inject(Router);
    const paramValue = route.paramMap.get(paramName) ?? '';

    return POSITIVE_INTEGER_PATTERN.test(paramValue)
      ? true
      : new RedirectCommand(router.parseUrl(APP_ROUTES.NOT_FOUND));
  };
}
